import React from 'react';
import { SelectMenu, Button } from 'evergreen-ui';
import PropTypes from 'prop-types';

const StatusFilter = ({ status, setStatus, disabled }) => {
  const options = [
    { label: 'All', value: 'all' },
    { label: 'Pending', value: 'pending' },
    { label: 'Approved', value: 'approved' },
    { label: 'Declined', value: 'declined' },
  ];

  const handleChange = (opt) => {
    if (setStatus) {
      setStatus(opt.value);
    }
  };

  // Only show active if the filter exists and it is not "All"
  const showActive = () => status && status !== options[0].value;

  return (
    <SelectMenu
      hasTitle={false}
      options={options}
      selected={status}
      onSelect={(v) => handleChange(v)}>

      <Button size="small" disabled={disabled} appearance={showActive() ? 'primary' : 'default'}>
        Status:
        {' '}
        {status ? options.find((opt) => opt.value === status).label : 'All'}
      </Button>
    </SelectMenu>
  );
};

StatusFilter.propTypes = {
  status: PropTypes.string,
  setStatus: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

StatusFilter.defaultProps = {
  disabled: false,
};

export default StatusFilter;
